// tslint:disable:no-bitwise naming-convention
import * as React from 'react';
export var Row = function Row(_ref) {
  var index = _ref.index,
      _ref$data = _ref.data,
      Node = _ref$data.component,
      treeData = _ref$data.treeData,
      order = _ref$data.order,
      records = _ref$data.records,
      style = _ref.style,
      isScrolling = _ref.isScrolling;
  return React.createElement(Node, Object.assign({}, records[order[index]], {
    style: style,
    isScrolling: isScrolling,
    treeData: treeData
  }));
};